import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-observacao-pessoa',
  templateUrl: './text-observacao-pessoa.component.html',
  styleUrls: ['./text-observacao-pessoa.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextObservacaoPessoaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
